export default "__VITE_ASSET__C$Jv$Wk6__"